//localhost
const Config = {
    BACKEND_URL : process.env.REACT_APP_BACKEND_URL,
    MOGU_PORTAL_MIDDLEWARE_BACKEND_URL:
      process.env.REACT_APP_MOGU_PORTAL_MIDDLEWARE_BACKEND_URL?.trim() || '',
    key: process.env.REACT_APP_KEY,
    iv: process.env.REACT_APP_IV,
    SELF_ONBOARDING_PORTAL_URL:
      process.env.REACT_APP_SO_URL?.trim() ||
      process.env.REACT_APP_SELF_ONBOARDING_PORTAL_URL ||
      '',
    /** Cancel calls LHDN per invoice with delays; allow long-running requests (default 10 min). */
    CANCEL_DOCUMENT_TIMEOUT_MS:
      Number(process.env.REACT_APP_CANCEL_DOCUMENT_TIMEOUT_MS) || 600000,
};
export default Config;
  